<template>
  <div class="culture-box">
    <div class="carousel-class">
      <el-carousel :interval="5000" arrow="always" height="530px">
        <el-carousel-item>
          <img src="../../assets/img/1.jpg" style="height: 530px; width: 100%; cursor: pointer" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="text-box">
      <div class="banner-text">
        <div class="banner-title" style="margin-top: -30px;display: flex;align-items: center;">
          <img src="../../assets/img/company.jpg" alt style="margin: 0px auto;" />
        </div>
      </div>
    </div>
    <div class="banner">
      <div class="company-content flex_s">
        <div class="company-detail">
          <!-- <p class="align_l detail-title">关于我们</p> -->
          <p class="row-desc">
            深圳市慧智创新网络有限公司成立于2023年12月22日，注册地位于深圳市宝安区西乡街道河西社区八十一区前进二路93号586。经营范围包括一般经营项目是：计算机软硬件开发等，是一家快速增长的跨境
            电商服务企业。
          </p>
          <!-- <div class="flex_e" style="margin-top: 10px;">
            <router-link :to="{ name: 'about' }">
              <el-button type="primary" round style="background-color:#004ea2 ;">了解更多</el-button>
            </router-link>
          </div> -->
        </div>
        <img src="../../assets/img/compay-img.jpg" alt />

      </div>
    </div>
    <div class="us-advantage" style="padding-bottom:40px;">
      <div class="text-box">
        <div class="banner-text">
          <div class="banner-title">
            <img src="../../assets/img/01.png" alt />
          </div>
        </div>
      </div>
      <div class="row-flex">
        <div class="row-item">
          <p class="row-title">产品和Listing管理</p>
          <div class="row-desc">
            <p>1.我们拥有完整的产品开发和刊登流程，立足于一系列垂直整合的宗旨，让产品更具竞争力，文案更具曝光度，图片更具代表性，品质更可靠；</p>
            <p>2.我们支持一键刊登和刊登后的Listing详情管理，包括亚马逊A+商品描述，有效提升卖家刊登效率。</p>
          </div>
        </div>
        <div class="row-item">
          <p class="row-title">价格和库存管理</p>
          <div class="row-desc">
            <p>1.根据库存和销量智能批量调整商品价格和库存，无需人工干预，我们的程序将完成这些工作； </p>
            <p>2.我们在获取库存、价格信息和销售信息后，会分析和管理库存，然后结合销售量、FBA时效等，建立自动化发货补货计划，确保优质产品稳定供应给买家。</p>
          </div>
        </div>
        <div class="row-item">
          <p class="row-title">物流管理</p>
          <div class="row-desc">
            <p>1.发送货物到亚马逊、FBA派送、自发货派送及跟进卖家收货过程，严格按照物流商的派送率和物流商的派送时间作为对物流商绩效考核的依据；</p>
            <p>2.直接淘汰不合格的物流商确保按时将货物交付给客户，对客户每个包裹负责。</p>
          </div>
        </div>
        <div class="row-item">
          <p class="row-title">客户服务管理</p>
          <div class="row-desc">
            <p>1.在获取到买家的询问邮件后，我们的程序会智能匹配当前的订单或产品信息，给客户一个更满意的答复；</p>
            <p>2.同时我们会征求买家的反馈，做出相应的提升，从而更好的服务买家客户。</p>
          </div>
        </div>
        <div class="row-item">
          <p class="row-title">订单管理</p>
          <div class="row-desc">
            <p>1.实现各平台订单自动抓取并自动推送到仓系统，避免订单漏发、错发;</p>
            <p>2.支持智能识别各种异常订单，帮助客户快速处理;</p>
            <p>3.支持分单下单等。</p>
          </div>
        </div>
        <div class="row-item">
          <p class="row-title">广告管理</p>
          <div class="row-desc">
            <p>1.实现销售伙伴店铺创建、授权、维护广告等功能;</p>
            <p>2.帮忙销售伙伴的广告投放和表现信息，帮助客户投放广告以及数据分析。</p>
          </div>
        </div>
        <div class="row-item">
          <p class="row-title">数据分析</p>
          <div class="row-desc">
            <p>1.多维度、更细致的运营分析；</p>
            <p>2.具有针对单一商品、单一站点、单一品牌、单一仓库和单一平台的自定义数据的商业智能 BI。</p>
            <p>3.合作伙伴可以根据自己的需求定制会计和财务报表、BI报表，还可以统计历史销售额、成本、利润、库存;</p>
            <p>4.您也可以根据自己的需求，计算出自己团队的人均利润，通过店铺Listing产品数据，
              对产品、用户画像、产业链、供应链进行更深入的分析，选择最合适的店铺 产品类型、价格和营销方式等等，从而制定店铺的爆款策略。
            </p>
          </div>
        </div>
        <div class="row-item">
          <p class="row-title">仓库管理</p>
          <div class="row-desc">
            <p>1.我们的仓库规划了智能货位；</p>
            <p>2.PDA用于仓储和拣选，流水线作业用于包装，大大提高了订单处理的及时性和准确性。</p>
          </div>
        </div>
      </div>
    </div>
    <div class="us-advantage" style="background-color: #fff;">
      <div class="text-box">
        <div class="banner-text">
          <div class="banner-title">
            <img src="../../assets/img/02.png" alt />
          </div>
          <p style="text-align: center;
              color: #515151;
              font-size: 16px;
              padding: 30px;
              font-weight: bold;">
            我们的亚马逊Selling Partner API应用及其他销售平台应用免费开放给销售伙伴使用
          </p>
        </div>

      </div>

    </div>
    <div class="us-advantage">
      <div class="text-box">
        <div class="banner-text">
          <div class="banner-title">
            <img src="../../assets/img/1.png" alt />
          </div>
        </div>
      </div>
      <div class="advantage-content">
        <ul class="banner">
          <el-carousel :interval="4000" type="card" height="400px">
            <el-carousel-item>
              <li class="content-tips">
                <i class="right-icon1"></i>
                <p class="tips-title">销售端管理</p>
                <p class="align_l">
                  通过对接亚马逊、eBay、速卖通、Wish、Lazada、Shopee等多个平台，实现了刊登和订单抓取，方便用户处理订单流程。
                </p>
              </li>
            </el-carousel-item>
            <el-carousel-item>
              <li class="content-tips">
                <i class="right-icon4"></i>
                <p class="tips-title">供应链管理</p>
                <p class="align_l">
                  研发了WMS（仓库系统）、PMS（采购系统）、计划系统等供应链模块，实现智能备发货等功能。
                </p>
              </li>
            </el-carousel-item>
            <el-carousel-item>

              <li class="content-tips">
                <i class="right-icon2"></i>
                <p class="tips-title">报表统计</p>
                <p class="align_l">
                  对各个维度的数据进行了详尽的统计，包括但不限于营业额、利润、销量、库存等，帮助客户监控公司业务。
                </p>
              </li>
            </el-carousel-item>
            <el-carousel-item>
              <li class="content-tips">
                <i class="right-icon3"></i>
                <p class="tips-title">基础数据管理</p>
                <p class="align_l">
                  包括产品管理、报告管理等模块，统筹管理公司业务信息。
                </p>
              </li>
            </el-carousel-item>
            <el-carousel-item>
              <li class="content-tips">
                <i class="right-icon5"></i>
                <p class="tips-title">智能模块</p>
                <p class="align_l">
                  智能补货、智能客服、智能调价、详尽的报表统计和趋势，可以有效的帮助销售伙伴提升效率和保持对买家稳定的高质量的服务。
                </p>
              </li>
            </el-carousel-item>
          </el-carousel>
        </ul>
      </div>
    </div>
    <div class="cooperation-platform">
      <div class="banner">
        <div class="common-tip banner">
          <div class="text-box">
            <div class="banner-text">
              <div class="banner-title">
                <img src="../../assets/img/co.jpg" alt />
              </div>
            </div>
          </div>
        </div>
        <div class="platform-list flex_b">
          <div class="banner-wrap">
            <ul>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-class" style="margin-top: 100px;">
      <img src="../../assets/img/footer.jpg" alt style="width:100%;" />
    </div>
    <mainBottom></mainBottom>
  </div>
</template>
<script>
import mainBottom from "@/components/container/bottom";
export default {
  components: { mainBottom },
};
</script>
<style scoped>
.carousel-class {
  height: 530px;
}

.company-content {
  height: 378px;
  width: 100%;
  margin-bottom: 124px;
}

.flex_e,
.flex_s {
  display: -webkit-box;
  display: flex;
}

.flex_s {
  -webkit-box-pack: start;
  justify-content: flex-start;
}

.company-content img {
  display: inline-block;
  height: 100%;
  width: 47%;
  background-color: #2893fb;
}

.company-content .company-detail {
  width: 49%;
  height: 140px;
  margin-top: 70px;
  /* background-color: #f6f6f8; */
  /* padding: 30px 2% 34px; */
  margin-right: 10px;
  padding: 30px 0 34px;

}

.company-content .company-detail .detail-title {
  font-weight: 600;
  line-height: 38px;
  font-size: 20px;
}

.align_l {
  text-align: left;
}

.company-content .company-detail .detail-content {
  line-height: 24px;
  text-indent: 2em;
  font-size: 14px;
}

.company-content .company-detail .more span {
  margin-left: 520px;
  cursor: pointer;
  font-size: 12px;
  margin-top: 10px;
  color: #999;
}

.company-content .company-detail .more :hover {
  color: #2893fb;
}

.us-advantage {
  background-color: #f6f6f8;
  overflow: hidden;
}

.us-advantage .advantage-content {
  margin: 0 auto;
  padding: 26px 0 130px;
}

.flex_a,
.flex_b {
  display: -webkit-box;
  display: flex;
}

.us-advantage .advantage-content .content-tips {
  width: 520px;
  height: 286px;
  background-color: #fff;
  padding: 37px 42px;
  border-radius: 8px;
  text-align: center;
  transition: All 0.2s ease-in-out;
  -webkit-transition: All 0.2s ease-in-out;
  -moz-transition: All 0.2s ease-in-out;
  -o-transition: All 0.2s ease-in-out;
  -ms-transition: All 0.2s ease-in-out;
  box-shadow: 10px 10px 15px -10px;
}

.us-advantage .advantage-content .content-tips .right-icon1 {
  background: url("../../assets/images/public.png") -391px -358px;
}

.us-advantage .advantage-content .content-tips .right-icon2 {
  background: url("../../assets/images/public.png") -511px -354px;
}

.us-advantage .advantage-content .content-tips .right-icon3 {
  background: url("../../assets/images/public.png") -391px -229px;
}

.us-advantage .advantage-content .content-tips .right-icon5 {
  background: url("../../assets/img/icon.jpg");
}

.us-advantage .advantage-content .content-tips .right-icon4 {
  background: url("../../assets/img/icon4.jpg");
}

.us-advantage .advantage-content .content-tips .tips-title {
  font-size: 20px;
  color: #6eb6fb;
  font-weight: 700;
  margin: 15px 0 28px;
  white-space: normal;
}

.us-advantage .advantage-content .content-tips i {
  width: 63px;
  height: 55px;
  text-align: center;
  display: inline-block;
}

body ul li {
  list-style: none;
  /* margin-left: 50px; */
}

.us-advantage .advantage-content .content-tips:hover {
  transform: scale(1.2);
  -webkit-transform: scale(1.2);
  -moz-transform: scale(1.2);
  -o-transform: scale(1.2);
  -ms-transform: scale(1.2);
}

.us-advantage .advantage-content .content-tips:hover p {
  padding: 10px;
}

.information-content {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  margin-bottom: 82px;
}

.information-content .tab-navbar {
  margin-bottom: 30px;
  text-align: center;
}

.information-content .tab-navbar ul {
  background-color: #f5f5f5;
  width: 900px;
  margin: 0 auto;
}

.information-content .tab-navbar ul li:first-child {
  width: 300px;
  background: url("../../assets/images/public.png") 0 -757px;
}

.information-content .tab-navbar ul li {
  height: 42px;
  line-height: 42px;
  margin-right: -22.5px;
  cursor: pointer;
}

.information-content .tab-navbar ul li:nth-child(2),
.information-content .tab-navbar ul li:nth-child(3) {
  width: 326px;
  background: url("../../assets/images/public.png") 1px -715px;
}

.information-content .tab-navbar ul .active_2 {
  color: #fff;
  background: url("../../assets/images/public.png") -166px -10px !important;
}

.information-content .video-player-box {
  width: 100%;
  background-color: #f5f5f5;
  position: relative;
}

.information-content .content-left {
  width: 32%;
  cursor: pointer;
}

.information-content .content-right {
  width: 63%;
}

.information-content .content-right .right-bottom {
  line-height: 51px;
  cursor: pointer;
}

.information-content .content-right .right-bottom .flex_b {
  border-bottom: 1px dashed #999;
}

.flex_e,
.flex_s {
  display: flex;
}

.flex_s {
  -webkit-box-pack: start;
  justify-content: flex-start;
}

.flex_b {
  -webkit-box-pack: justify;
  justify-content: space-between;
}

.information-content .content-right .right-bottom .flex_b .dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: #339afe;
  border-radius: 50%;
  margin: 20px 10px 0 0;
}

.information-content .content-right .right-bottom .flex_b .text {
  width: 620px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

ul li {
  padding: 0;
  margin: 0;
  list-style: none;
  border: 0;
  font-family: 方正黑体;
  font-size: 15px;
}

.cooperation-platform {
  height: 350px;
  overflow: hidden;
  background-color: #fff;
}

.cooperation-platform .platform-list {
  margin-bottom: 68px;
  margin-top: 7px;
  height: 58px;
}

.cooperation-platform .platform-list .left {
  background: url("../../assets/images/public.png") -65px -635px;
}

.cooperation-platform .platform-list span {
  display: inline-block;
  width: 35px;
  height: 58px;
}

.cooperation-platform .platform-list .banner-wrap {
  position: relative;
  width: 1255px;
  padding: 0 8px;
  overflow: hidden;
  margin-top: 0;
  height: 300px;
}

.cooperation-platform .platform-list .right {
  background: url("../../assets/images/public.png") -10px -635px;
}

.cooperation-platform .platform-list ul li {
  width: 180px;
  height: 58px;
  margin-right: 10px;
  margin-top: 15px;
  float: left;
}

.cooperation-platform .platform-list ul li:nth-child(1) {
  background: url("../../assets/images/public.png") -638px -88px;
}

.cooperation-platform .platform-list ul li:nth-child(2) {
  background: url("../../assets/images/public.png") -638px -10px;
}

.cooperation-platform .platform-list ul li:nth-child(3) {
  background: url("../../assets/images/public.png") -638px -166px;
}

.cooperation-platform .platform-list ul li:nth-child(4) {
  background: url("../../assets/images/public.png") -10px -487px;
}

.cooperation-platform .platform-list ul li:nth-child(5) {
  background: url("../../assets/images/public.png") -638px -244px;
}

.cooperation-platform .platform-list ul li:nth-child(6) {
  background: url("../../assets/images/public.png") -638px -478px;
}

.cooperation-platform .platform-list ul li:nth-child(7) {
  background: url("../../assets/images/public.png") -638px -400px;
}

.cooperation-platform .platform-list ul li:nth-child(8) {
  background: url("../../assets/images/public.png") -638px -322px;
}

.information-content .tab-navbar ul .active_0 {
  color: #fff;
  background: url("../../assets/images/public.png") -10px -167px !important;
}

.information-content .tab-navbar ul .active_7 {
  color: #fff;
  background: url("../../assets/images/public.png") -167px -73px !important;
}

.information-content .tab-navbar ul .active_2 {
  color: #fff;
  background: url("../../assets/images/public.png") -166px -10px !important;
}

.information-content .content-left img {
  width: 100%;
  height: 222px;
}

.information-content .content-left .left-bottom {
  height: 190px;
  padding: 2%;
  background-color: #f5f5f5;
}

.information-content .content-left .left-bottom p {
  text-align: left;
}

.information-content .content-left .left-bottom p:nth-child(2) {
  text-indent: 2em;
}

.information-content .content-left .left-bottom p:first-child {
  font-weight: 600;
  margin: 10px 0;
}

.hot {
  display: inline-block;
  width: 20px;
  height: 19px;
  background: url("../../assets/images/public.png") -597px -269px;
  vertical-align: middle;
}

.information-content .content-right .right-bottom .flex_b:hover {
  color: #339afe;
}

.more .check-more {
  margin-top: 10px;
  font-size: 12px;
  color: #999;
  margin-left: 93%;
}

.row-flex {
  width: 90%;
  margin: 0px auto;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.row-item {
  width: 22%;
  height: auto;

  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.06);
  margin-bottom: 30px;
  margin-left: 15px;
  margin-right: 15px;
}

.row-title {
  /* color:#004ea2; */
  font-size: 26px;
  text-align: center;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(36, 104, 242, 1);
  padding-top: 30px;
}

.row-desc {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(81, 81, 81, 1);
  line-height: 25px;
  padding: 20px 15px;
  /* height: 200px; */
}

.row-item .row-desc {
  height: 285px;
}
</style>

